var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIndex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.83203H4.16667C3.24619 5.83203 2.5 6.57822 2.5 7.4987V17.4987C2.5 18.4192 3.24619 19.1654 4.16667 19.1654H10.8333C11.7538 19.1654 12.5 18.4192 12.5 17.4987V10.832M7.5 5.83203L12.5 10.832M7.5 5.83203V10.832H12.5M12.5 0.832031H9.16667C8.24619 0.832031 7.5 1.57822 7.5 2.4987V3.33203M12.5 0.832031L17.5 5.83203M12.5 0.832031V5.83203H17.5M17.5 5.83203V12.4987C17.5 13.4192 16.7538 14.1654 15.8333 14.1654H15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndex);
export default __webpack_public_path__ + "static/media/icon-index.94586b419bf50ae82290ad9c6282cdfc.svg";
export { ForwardRef as ReactComponent };